import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "overflow-auto w-full p-5",
  style: {"height":"calc(100% - 5rem)"}
}
const _hoisted_2 = {
  class: "overflow-auto border border-line rounded-md",
  style: {"height":"40rem","max-height":"40rem"}
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"flex 1px-3 1py-4 text-placeholder\"><div class=\"px-3 py-4 border-b border-line\" style=\"min-width:10rem;max-width:10rem;\">공정</div><div class=\"px-3 py-4 border-b border-line\" style=\"min-width:12rem;max-width:12rem;\">재료</div><div class=\"px-3 py-4 border-b border-line\" style=\"min-width:13rem;max-width:13rem;\">협력사</div><div class=\"px-3 py-4 border-b border-line\" style=\"min-width:15rem;max-width:15rem;\">장비</div><div class=\"px-3 py-4 border-b border-line\" style=\"min-width:16.5rem;max-width:16.5rem;\">출력크기(mm) x*y*z</div><div class=\"px-3 py-4 border-b border-line\" style=\"min-width:5rem;max-width:5rem;\">도색</div><div class=\"px-3 py-4 border-b border-line\" style=\"min-width:5rem;max-width:5rem;\">후처리</div><div class=\"px-3 py-4 border-b border-line\" style=\"min-width:6rem;max-width:6rem;\">단가비율</div><div class=\"px-3 py-4 border-b border-line\" style=\"min-width:9rem;max-width:9rem;\">최소비용(원)</div><div class=\"px-3 py-4 border-b border-line\" style=\"min-width:9rem;max-width:9rem;\">장비 이용료(원)</div><div class=\"px-3 py-4 border-b border-line\" style=\"min-width:9rem;max-width:9rem;\">재료단가(원)</div></div>", 1)
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = {
  class: "px-3 py-2 border-r border-line",
  style: {"min-width":"10rem","max-width":"10rem"}
}
const _hoisted_6 = {
  class: "cs-form flex w-full",
  "data-height": "xs"
}
const _hoisted_7 = { class: "mt-10 text-right" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "저장", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_process_item = _resolveComponent("process-item")!
  const _component_loader_button = _resolveComponent("loader-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processList, (process) => {
        return (_openBlock(), _createBlock(_component_process_item, {
          key: process.id,
          process: process
        }, null, 8, ["process"]))
      }), 128)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              class: "",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.processName) = $event)),
              type: "text",
              placeholder: "",
              onKeypress: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onAddProcess && _ctx.onAddProcess(...args)), ["enter"]))
            }, null, 544), [
              [_vModelText, _ctx.processName]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_loader_button, {
        ref: "submit",
        class: "w-56 cs-pd-btn-lg",
        cssButton: 'cs-btn-base',
        onClick: _ctx.onSubmit
      }, {
        title: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}